// Dunea's own admin extension cards, registered once (imported by ./index).
// Each feature adds one registerAdminCard call here; keep ids stable
// ("<feature>.<card>") and orders spaced so features can slot between.

import { ProductReviewsCard } from '~/components/workbench/tools/reviews/ProductReviewsCard';
import { CustomFieldsCard } from '~/components/workbench/tools/content/CustomFieldsCard';
import { CUSTOM_FIELD_TARGETS } from '~/components/workbench/tools/content/content-model';
import type { AdminTarget } from '@dunea/plugin-sdk';
import { registerAdminCard } from './registry';

// Custom data: the pinned custom fields (metafields) of the resource, editable in place.
for (const target of Object.keys(CUSTOM_FIELD_TARGETS) as AdminTarget[]) {
  registerAdminCard(target, {
    id: 'data.custom-fields',
    title: 'Custom fields',
    order: 20,
    Component: CustomFieldsCard,
  });
}

// Reviews: the product's rating summary on its detail view.
registerAdminCard('shop.product.details', {
  id: 'reviews.product-rating',
  title: 'Reviews',
  order: 50,
  Component: ProductReviewsCard,
});
